"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const hooks_1 = require("../../hooks");

const useOutsideClick_1 = __importDefault(require("../../hooks/useOutsideClick"));

const react_1 = require("react");

const helpers_1 = require("./helpers");

const MenuItem_1 = __importDefault(require("./MenuItem"));

const MenuList_1 = __importDefault(require("./MenuList"));

const styles_1 = require("./styles");

const Menu = props => {
  const {
    children,
    anchorNodeRef,
    menuListProps,
    hasCustomWrapper,
    isOpen = false,
    position = 'bottom',
    onClose = () => {}
  } = props;
  const menuRef = (0, react_1.useRef)(null);
  const [coords, setCoords] = (0, react_1.useState)({
    left: 0,
    top: 0
  });
  const isOnScreen = (0, hooks_1.useDelayedUnmount)(isOpen, 200);

  const handleClick = () => {
    if (!isOpen) {
      return;
    }

    onClose();
  };

  (0, useOutsideClick_1.default)(menuRef, handleClick);
  (0, react_1.useEffect)(() => {
    const updateCoords = () => {
      const newCoords = (0, helpers_1.getMenuPosition)(anchorNodeRef === null || anchorNodeRef === void 0 ? void 0 : anchorNodeRef.current, position);

      if (newCoords.left !== coords.left || newCoords.top !== coords.top) {
        setCoords(newCoords);
      }
    };

    updateCoords();
    window.addEventListener('scroll', updateCoords, {
      passive: true
    });
    window.addEventListener('resize', updateCoords, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', updateCoords);
      window.removeEventListener('resize', updateCoords);
    };
  }, [anchorNodeRef, coords, position]);

  if (!isOnScreen || hasCustomWrapper && !isOpen) {
    return null;
  }

  return (0, jsx_runtime_1.jsx)(styles_1.MenuContainer, Object.assign({
    coordinates: coords,
    position: position,
    ref: menuRef
  }, {
    children: hasCustomWrapper ? children : (0, jsx_runtime_1.jsx)(MenuList_1.default, Object.assign({
      position: position,
      isOpen: isOpen
    }, menuListProps, {
      children: children
    }), void 0)
  }), void 0);
};

Menu.List = MenuList_1.default;
Menu.Item = MenuItem_1.default;
exports.default = Menu;